export default __webpack_public_path__ + "static/media/dc.a4bc8766.png";